/* ============================================================================
   announcement.js — <nko-announcement>, die Ankuendigungsleiste ueber dem
   Header (Crossfade)
   ----------------------------------------------------------------------------
   Geladen von sections/announcement.liquid als <script type="module">, und
   nur, wenn es mehr als eine Meldung gibt — mit einer einzigen rotiert
   nichts. Stand bis M3 in nko-chrome.js.

   Ersetzt Swiper auf `.js-header-msg` (app.js:1102: loop, fade, autoplay
   3000). Swiper kostete im Legacy-Bundle ~60 KB; die Leiste braucht davon
   einen Fade und einen Timer. Die Blende selbst macht CSS (header.css §4,
   `.msg__slide[data-active]`), hier wird nur das Attribut umgesetzt.
   ==========================================================================  */

class NkoAnnouncement extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll("[data-slide]")];
    if (this.slides.length < 2) return;

    this.index = this.slides.findIndex((s) => s.hasAttribute("data-active"));
    if (this.index < 0) this.index = 0;

    this.delay = Number(this.dataset.delay) || 3000;
    this.paused = false;

    /* OB UEBERHAUPT ROTIERT WIRD, steht in EINEM Merker (P2-9). Vorher rief
       der visibilitychange-Hoerer beim Zurueckkehren in den Tab bedingungslos
       start() — die Leiste rotierte dann auch bei reduzierter Bewegung und
       nach dem Blaettern mit den Pfeilen wieder, obwohl beides sie anhalten
       soll. Wer blaettert, hat die Kontrolle uebernommen; wie Swiper mit
       `disableOnInteraction` bleibt sie dann stehen. */
    this.autoplay = !matchMedia("(prefers-reduced-motion: reduce)").matches;

    /* Alle Hoerer an EINEM Signal: im Theme-Editor wird die Section bei jeder
       Aenderung neu gerendert, und der Hoerer am document samt Intervall
       liefe sonst weiter. */
    this.ac = new AbortController();
    const { signal } = this.ac;

    this.querySelector("[data-prev]")?.addEventListener(
      "click",
      () => {
        this.autoplay = false;
        this.stop();
        this.go(this.index - 1);
      },
      { signal }
    );
    this.querySelector("[data-next]")?.addEventListener(
      "click",
      () => {
        this.autoplay = false;
        this.stop();
        this.go(this.index + 1);
      },
      { signal }
    );

    // Beim Ueberfahren anhalten, damit ein Link auch getroffen werden kann.
    this.addEventListener("pointerenter", () => (this.paused = true), { signal });
    this.addEventListener("pointerleave", () => (this.paused = false), { signal });
    this.addEventListener("focusin", () => (this.paused = true), { signal });
    this.addEventListener("focusout", () => (this.paused = false), { signal });

    // Im Hintergrundtab nicht weiterlaufen lassen.
    document.addEventListener(
      "visibilitychange",
      () => {
        if (document.hidden) this.stop();
        else if (this.autoplay) this.start();
      },
      { signal }
    );

    // Im Theme-Editor zum gewaehlten Block springen und dort stehen bleiben.
    this.addEventListener(
      "shopify:block:select",
      (e) => {
        const n = this.slides.findIndex((s) => s.contains(e.target));
        if (n < 0) return;
        this.stop();
        this.go(n);
      },
      { signal }
    );

    if (this.autoplay) this.start();
  }

  disconnectedCallback() {
    this.stop();
    this.ac?.abort();
  }

  start() {
    this.stop();
    this.timer = setInterval(() => {
      if (!this.paused) this.go(this.index + 1);
    }, this.delay);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  go(next) {
    const n = (next + this.slides.length) % this.slides.length;
    this.slides[this.index]?.removeAttribute("data-active");
    this.slides[n].setAttribute("data-active", "");
    this.index = n;
  }
}

if (!customElements.get("nko-announcement")) {
  customElements.define("nko-announcement", NkoAnnouncement);
}

/* NUR ALS MODUL LADEN: <script src="…" type="module">, nie mit `defer` —
   der Modulbereich ist der einzige Gueltigkeitsbereich dieser Datei. */
